import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const reviews = [{
  name: 'Valentina G.',
  location: 'Salta',
  cat: 'Canela, 3 años',
  stars: 5,
  text: 'Canela me hacía pis en las macetas del balcón. Yo pensaba que era porque le gustaba la tierra. Resulta que la bandeja estaba demasiado cerca de su comedero y eso le generaba rechazo. La moví siguiendo el protocolo y en 48 horas dejó las macetas en paz. Increíble lo simple que era la solución.'
}, {
  name: 'Sebastián M.',
  location: 'San Juan',
  cat: 'Rocky, 6 años',
  stars: 5,
  text: 'Rocky es un gato enorme, de 7 kilos. La bandeja que teníamos era chica y él se sentía incómodo. Con la guía entendí que necesitaba una bandeja más grande y en otra ubicación. Hice los dos cambios juntos y al segundo día ya estaba usándola sin problemas. Mi señora me abrazó cuando vio que funcionó.'
}, {
  name: 'Carolina T.',
  location: 'Paraná',
  cat: 'Milo, 2 años',
  stars: 5,
  text: 'Adopté a Milo de la calle y desde el día uno me marcaba las zapatillas. Probé de todo: repelentes, spray con agua, encerrarlo en un cuarto. Nada. Con el protocolo entendí que Milo necesitaba zonas seguras propias. Le armé su espacio como dice la guía y en 5 días dejó mis zapatillas en paz.'
}, {
  name: 'Ramiro F.',
  location: 'Corrientes',
  cat: 'Nube, 4 años',
  stars: 5,
  text: 'Mi mamá me regaló la guía porque ya no sabía qué hacer con Nube. Yo la leí medio por compromiso, pero cuando hice la auditoría express me di cuenta de que tenía la bandeja al lado de la puerta de entrada. Cada vez que alguien tocaba el timbre, Nube se estresaba. La moví y santo remedio.'
}, {
  name: 'Julieta H.',
  location: 'Bariloche',
  cat: 'Thor y Loki, 3 y 2 años',
  stars: 5,
  text: 'Con dos gatos machos la cosa era un desastre. Se marcaban territorio entre ellos y mi departamento olía horrible. El protocolo me enseñó a armar zonas separadas y poner bandejas estratégicas. En una semana se calmó todo. Ahora hasta comparten el sillón sin drama. No lo puedo creer.'
}, {
  name: 'Pablo N.',
  location: 'Resistencia',
  cat: 'Michi, 5 años',
  stars: 5,
  text: 'Yo limpiaba con productos con amoníaco sin saber que eso EMPEORABA todo. El gato olía el amoníaco y pensaba que era orina de otro gato, así que volvía a marcar encima. Cuando cambié el producto de limpieza con lo que dice el bono, fue como magia. En 3 días dejó de marcar la esquina del living.'
}, {
  name: 'Antonella R.',
  location: 'Posadas',
  cat: 'Princesa, 7 años',
  stars: 5,
  text: 'Princesa empezó a hacer pis fuera de la bandeja cuando le cambié la arena. Yo pensé que era caprichosa. La guía me explicó que los gatos son MUY sensibles a los cambios de textura y olor de la arena. Volví a la anterior y seguí el protocolo de transición. En 2 días volvió a la bandeja como si nada.'
}, {
  name: 'Nicolás W.',
  location: 'Ushuaia',
  cat: 'Garfield, 4 años',
  stars: 5,
  text: 'Garfield me meaba la ropa que dejaba en el piso. Mi novia estaba harta y me dijo "o solucionás esto o el gato se va". Compré la guía desesperado y descubrí que Garfield marcaba mi ropa porque tenía ansiedad por separación. Seguí los pasos del protocolo y en una semana se terminó el problema. Salvé al gato Y a la relación.'
}, {
  name: 'María José C.',
  location: 'San Luis',
  cat: 'Copito, 9 años',
  stars: 5,
  text: 'Copito tiene 9 años y nunca había tenido problemas hasta que le pusimos una bandeja cerrada con tapa. Pensábamos que era más higiénica, pero a él le daba claustrofobia. Sacamos la tapa como dice la guía y volvió a usarla al toque. A veces la solución es más simple de lo que uno piensa.'
}, {
  name: 'Esteban L.',
  location: 'Río Gallegos',
  cat: 'Manchas, 3 años',
  stars: 5,
  text: 'Manchas marcaba detrás del sofá y yo no me daba cuenta hasta que el olor era insoportable. Con la auditoría del bono 1 encontré el punto exacto y con la receta de limpieza del bono eliminé el olor por completo. Después reubiqué la bandeja y listo. Llevo un mes sin un solo accidente. Recomendadísimo.'
}];
export function ReviewsSection2() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const goTo = (index: number) => {
    setDirection(index > current ? 1 : -1);
    setCurrent(index);
  };
  const goNext = () => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % reviews.length);
  };
  const goPrev = () => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + reviews.length) % reviews.length);
  };
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0
    })
  };
  const review = reviews[current];
  return <section className="w-full bg-[#FAFAF7] py-8 md:py-20 px-4 md:px-6" data-id="element-363">
      <div className="max-w-3xl mx-auto" data-id="element-364">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 md:mb-10" data-id="element-365">
          
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-366">
            Ellos también lo resolvieron
          </h2>
          <p className="text-lg text-[#1C1C1C]/70 max-w-2xl mx-auto" data-id="element-367">
            Más dueños de gatos que dejaron de sufrir y recuperaron la paz de su
            hogar con el protocolo.
          </p>
        </motion.div>

        {/* Carousel */}
        <div className="relative" data-id="element-368">
          <button onClick={goPrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-14 z-10 w-10 h-10 bg-white rounded-full shadow-md border border-[#1C1C1C]/10 flex items-center justify-center hover:bg-[#FAFAF7] transition-colors cursor-pointer" aria-label="Reseña anterior" data-id="element-369">
            <ChevronLeftIcon className="w-5 h-5 text-[#1C1C1C]/70" data-id="element-370" />
          </button>
          <button onClick={goNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-14 z-10 w-10 h-10 bg-white rounded-full shadow-md border border-[#1C1C1C]/10 flex items-center justify-center hover:bg-[#FAFAF7] transition-colors cursor-pointer" aria-label="Reseña siguiente" data-id="element-371">
            <ChevronRightIcon className="w-5 h-5 text-[#1C1C1C]/70" data-id="element-372" />
          </button>

          <div className="overflow-hidden rounded-xl mx-6 md:mx-0" data-id="element-373">
            <div className="relative min-h-[260px] md:min-h-[220px]" data-id="element-374">
              <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-375">
                <motion.div key={current} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
                x: {
                  type: 'spring',
                  stiffness: 300,
                  damping: 30
                },
                opacity: {
                  duration: 0.2
                }
              }} drag="x" dragConstraints={{
                left: 0,
                right: 0
              }} dragElastic={0.12} onDragEnd={(_, info) => {
                if (info.offset.x < -60) goNext();else if (info.offset.x > 60) goPrev();
              }} className="bg-white rounded-xl p-6 md:p-8 border border-[#1C1C1C]/5 shadow-sm cursor-grab active:cursor-grabbing" data-id="element-376">
                  <div className="flex items-center gap-1 mb-3" data-id="element-377">
                    {Array.from({
                    length: review.stars
                  }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#F59E0B] fill-[#F59E0B]" data-id="element-378" />)}
                  </div>
                  <p className="text-[#1C1C1C] text-sm md:text-base leading-relaxed mb-5" data-id="element-379">
                    "{review.text}"
                  </p>
                  <div className="flex items-center justify-between" data-id="element-380">
                    <div data-id="element-381">
                      <p className="text-sm font-semibold text-[#1C1C1C]" data-id="element-382">
                        {review.name}
                      </p>
                      <p className="text-xs text-[#1C1C1C]/50" data-id="element-383">
                        {review.location} · 🐱 {review.cat}
                      </p>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-6" data-id="element-384">
          {reviews.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`transition-all duration-300 rounded-full cursor-pointer ${index === current ? 'w-6 h-2.5 bg-[#2D8C5A]' : 'w-2.5 h-2.5 bg-[#1C1C1C]/15 hover:bg-[#1C1C1C]/30'}`} aria-label={`Ir a reseña ${index + 1}`} data-id="element-385" />)}
        </div>
      </div>
    </section>;
}